export default "__VITE_ASSET__Cp7pvCsz__"